import React from "react"
import { About } from "../components/about"


export const AboutPage: React.FC = () =>{
  return (
    <div className="page">
      <About/>
      </div>
    )
}